

const Card = ({className, children}) => {
  return (
    <article className={`card ${className}__card`}>
        {children}
    </article>
  )
}

export default Card

// <Card className="sectionName">children</Card>